export const GunIcon = ({ className = '' }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    {/* Head */}
    <path d="M3 7.5C3 6.12 4.12 5 5.5 5h7c1.38 0 2.5 1.12 2.5 2.5v1c0 1.38-1.12 2.5-2.5 2.5H9.8l-1.3 1.3c-.19.2-.45.3-.72.3H6.5C4.57 12.6 3 11.03 3 9.1v-1.6z" />
    {/* Handle */}
    <path d="M10 12h3.5c.83 0 1.5.67 1.5 1.5V16c0 .55-.45 1-1 1H12l-1.8 2.4c-.19.26-.49.4-.8.4H7.5c-.83 0-1.5-.67-1.5-1.5v-.2c0-.32.1-.63.3-.88L8 15.5c.28-.37.72-.6 1.2-.6H10v-2z" />
    {/* Trigger */}
    <rect x="12.9" y="12.5" width="1.4" height="1.8" rx=".3" />
    {/* Scan rays */}
    <path d="M18 7h3v1.5h-3V7zm0 3h4v1.5h-4V10z" />
  </svg>
)